<template>
    <div
        class="chat-preview"
        v-if="widgetParameters.colors"
        :style="{width: widgetParameters.widgetWidth +'px', float: direction.float, textAlign: direction.textAlign , direction: widgetParameters.direction, right: direction.position}"
    >
        <div class="card">
            <div :style="{background : widgetParameters.colors.header }" class="card-header">
                <img v-if="widgetParameters.logo" class="logo" :src="widgetParameters.logo" alt="logo">
                <div :style="{color: widgetParameters.colors.headerFont}">
                    <h5>{{ widgetParameters.header }}</h5>
                    <h6>{{ widgetParameters.subHeader}}</h6>
                </div>
                <span class="widget-chat-close">x</span>
            </div>
            <div class="card-body">
                <div class="chat-body-wrapper" :style="{height: widgetParameters.widgetHeight + 'px', backgroundImage: 'url(' + widgetParameters.chatBackgroundImage + ')' }">
                    <div class="chat-body" :style="{fontSize: widgetParameters.fontSize +'px !important'}">
                        <p class="bot-side"
                           :style="{color: widgetParameters.colors.chatBotAnswerFont , background: widgetParameters.colors.chatBotAnswer , borderRadius: botSideRadius, float: direction.botFloat, fontSize: widgetParameters.fontSize +'px'}"
                        > Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                        </p>
                        <p class="user-side"
                           :style="{color: widgetParameters.colors.userSideFont , background: widgetParameters.colors.userSide, borderRadius: userSideRadius, float: direction.userFloat, fontSize: widgetParameters.fontSize +'px'}"
                        > Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                        </p>
                    </div>
                </div>
                <div class="chat-input" :style="{direction: widgetParameters.direction}">
                    <div class="row">
                        <div class="col-xs-2">
                            <svg height="35" viewBox="0 0 25.75 46" width="35"><path d="M20.75 11.75v21.37a7.69 7.69 0 0 1-.62 3.07 7.95 7.95 0 0 1-4.19 4.19 7.89 7.89 0 0 1-6.13 0 7.95 7.95 0 0 1-4.19-4.19 7.69 7.69 0 0 1-.62-3.07v-22.5a5.27 5.27 0 0 1 .45-2.17 5.69 5.69 0 0 1 3-3 5.48 5.48 0 0 1 4.35 0 5.69 5.69 0 0 1 3 3 5.27 5.27 0 0 1 .45 2.17v22.5a3.41 3.41 0 0 1-.26 1.32 3.31 3.31 0 0 1-1.8 1.8 3.46 3.46 0 0 1-2.63 0 3.31 3.31 0 0 1-1.8-1.8 3.41 3.41 0 0 1-.26-1.32V14h2.25v19.12a1.13 1.13 0 1 0 2.25 0v-22.5a3.4 3.4 0 0 0-.26-1.31 3.31 3.31 0 0 0-1.8-1.8 3.46 3.46 0 0 0-2.63 0 3.31 3.31 0 0 0-1.8 1.8 3.4 3.4 0 0 0-.26 1.31v22.5a5.32 5.32 0 0 0 .45 2.18 5.69 5.69 0 0 0 3 3 5.48 5.48 0 0 0 4.35 0 5.69 5.69 0 0 0 3-3 5.32 5.32 0 0 0 .45-2.18v-21.37z" clip-rule="evenodd"></path></svg>
                        </div>
                        <div class="col-xs-8">
                            Type Your Message
                        </div>
                        <div class="col-xs-2">
                            <svg height="35" viewBox="0 0 45.7 33.8" width="35"><path d="M8.55 25.25l21.67-7.25H11zm2.41-9.47h19.26l-21.67-7.23zm-6 13l4-11.9L5 5l35.7 11.9z" clip-rule="evenodd"></path></svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :style="{textAlign: direction.float}">
            <button class="btn btn-primary openBubbleImage" :style="{background : widgetParameters.colors.header }">
                <img :src="widgetParameters.openBubbleImage" alt="">
            </button>
        </div>
        <v-style>
            @import url('https://fonts.googleapis.com/css?family={{widgetParameters.font}}');
            .chat-preview {
            font-family: {{widgetParameters.font}}, sans-serif !important;
            }
            .chat-preview h5 , .chat-preview h6 {
            font-family: {{widgetParameters.font}}, sans-serif !important;
            }
        </v-style>
    </div>
</template>

<script>
    export default {
        name: "widgetReview",
        props: {
            widgetParameters: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data () {
            return {
                userSideRadius: '0',
                botSideRadius: '0',
                direction: {
                    float: 'right',
                    textAlign: 'left',
                    userFloat: 'right',
                    botFloat: 'left',
                    position: '10px'
                }
            }
        },
        mounted () {

        },
        methods: {
          changeShape(){
              if (this.widgetParameters.chatBubble === 'rounded' && this.widgetParameters.direction === 'rtl') {
                  this.userSideRadius = '0 20px 20px 20px'
                  this.botSideRadius = '20px 0 20px 20px'
              } else if (this.widgetParameters.chatBubble  === 'curvey' && this.widgetParameters.direction === 'rtl') {
                  this.userSideRadius = '0 5px 5px 5px'
                  this.botSideRadius = '5px 0px 5px 5px'
              } else if (this.widgetParameters.chatBubble === 'rounded' && this.widgetParameters.direction === 'ltr') {
                  this.userSideRadius = '20px 0 20px 20px'
                  this.botSideRadius = '0px 20px 20px 20px'
              } else if (this.widgetParameters.chatBubble === 'curvey' && this.widgetParameters.direction === 'ltr') {
                  this.userSideRadius = '5px 0 5px 5px'
                  this.botSideRadius = '0px 5px 5px 5px'
              } else {
                  this.userSideRadius = '0'
                  this.botSideRadius = '0'
              }
          }
        },
        watch: {
            'widgetParameters.chatBubble': function (state) {
                this.changeShape()
            },
          'widgetParameters.direction': function(state) {
            if (state === 'rtl') {
                this.direction.float = 'left'
                this.direction.textAlign = 'right'
                this.direction.userFloat = 'left'
                this.direction.botFloat = 'right'
                this.direction.position = '100px'
            } else {
                this.direction.float = 'right'
                this.direction.textAlign = 'left'
                this.direction.userFloat = 'right'
                this.direction.botFloat = 'left'
                this.direction.position = '10px'
            }

            this.changeShape()
          }
        },
    }
</script>

<style scoped>
    .chat-preview {
        padding-right: 20px;
        position: fixed;
        right: 10px;
        top: 55%;
        transform: translate(0, -50%);
    }
    .chat-preview .card-header {
        padding: 0 30px;
        position: relative;
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 10;
        background: #007FE8;
    }
    .chat-preview .logo {
        width: 70px;
        height: 70px;
        object-fit: contain;
        margin: 7px 0;
    }
    .chat-preview h5 {
        font-size: 25px;
        margin-bottom: 5px;
    }
    .chat-preview h6 {
        font-size: 17px;
    }
    .widget-chat-close {
        font-size: 25px;
        color: #F3F3F3;
    }
    .openBubbleImage{
        border-radius: 50%;
        width: 80px;
        height: 80px;
        padding: 0;
        box-shadow: 0px 6px 8px 2px rgba(0, 0, 0, 0.14);
    }
    .openBubbleImage img {
        height: 32px;
        filter: brightness(0) invert(1);
    }
    .chat-body-wrapper {
        position: relative;
        height: 550px;
        background-size: cover;
    }
    .chat-preview .card-body {
        padding: 0;
    }

    .chat-preview .chat-body {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 20px;
    }
    .chat-preview .chat-body p {
        font-size: 16px;
        width: 80%;
        margin-bottom: 15px;
        padding: 14px;
    }
    .chat-preview .bot-side {
        float: left;
    }
    .chat-preview .user-side {
        float: right;
    }
    .chat-preview .chat-input {
        background-color: white;
        min-height: 40px;
        -webkit-box-align: stretch;
        align-items: stretch;
        border-top: 1px solid rgb(230, 230, 230);
        padding: 2px 5px;
        direction: ltr;
    }
    .chat-preview .row {
        margin: 0;
        display: flex;
        align-items: center;
    }
    .chat-preview .row > div:nth-of-type(1) {-webkit-flex-grow: 1;}
    .chat-preview .row >div:nth-of-type(2) {-webkit-flex-grow: 32;}
</style>